import React, {Component} from "react";
import {Grid} from '@material-ui/core';
import ShowSkill from "../../components/Skills/ShowSkill/ShowSkill";
import skillData from '../../assets/static/skills.json';
import classes from './Skills.module.css';

class Skills extends Component {
	render() {
		let skills = skillData.skills;
		return (
			<div className={classes.Skills}>
				<div className={classes.Header}>
					<h2>Skills Overview</h2>
					<p>Below are some of the technologies I use in my daily job. </p>
					<p>Want to find out more about my experience? <a href={"/resume"}>Click here</a></p>
				</div>
				<Grid container spacing={2} alignItems={"center"} justify={"center"}>
					{skills.map(skill => (
						<Grid item sm={12} md={4} key={skill.id} style={{width: '100%'}}>
							<ShowSkill skill={skill}/>
						</Grid>
					))}
				</Grid>
			</div>
		)
	}
}

export default Skills;